import {
  Sparkles,
  Moon,
  Camera,
  Calculator,
  HeartPulse,
  ChefHat,
  ShoppingBasket,
  Dumbbell,
  Flame,
  Cookie,
  BookOpen,
  LayoutDashboard,
  Brain,
  UserCog,
} from "lucide-react";

export const FEATURES = [
  {
    icon: Sparkles,
    title: "AI-Powered Wellness Coach",
    blurb:
      "Adaptive coaching that learns your cycle, hormones, energy, recovery and goals — and adjusts in real time.",
    span: "md:col-span-2 md:row-span-2",
    accent: true,
  },
  {
    icon: Moon,
    title: "Cycle Syncing Intelligence",
    blurb:
      "Phase-by-phase guidance for nutrition, training, sleep, fasting and seed cycling.",
    span: "md:col-span-2",
  },
  {
    icon: Camera,
    title: "Smart Food Logging",
    blurb:
      "Describe a meal, scan labels in bulk, snap a plate, upload a recipe — the AI handles macros & micros.",
    span: "",
  },
  {
    icon: Calculator,
    title: "Macro & Calorie Planning",
    blurb:
      "Dynamic targets shaped by your hormones, recovery and goals — leaning, toning and beyond.",
    span: "",
  },
  {
    icon: HeartPulse,
    title: "Symptom & Mood Tracking",
    blurb:
      "Bloating, energy, brain fog, cravings, libido, sleep — the AI reads patterns so you don't have to.",
    span: "md:col-span-2",
  },
  {
    icon: ChefHat,
    title: "AI Meal Planning",
    blurb:
      "Daily, cycle-aware meal plans with personalised recipes.",
    span: "",
  },
  {
    icon: ShoppingBasket,
    title: "Smart Shopping Lists",
    blurb:
      "Auto-generated 7-day grocery lists synced to your meal plan.",
    span: "",
  },
  {
    icon: Dumbbell,
    title: "Workouts & Recovery",
    blurb:
      "Cycle-aware movement, AI-estimated burn, sweat, intensity and post-workout mood.",
    span: "md:col-span-2",
  },
  {
    icon: Flame,
    title: "Recovery Therapies",
    blurb:
      "Red light, sauna, ice baths, compression, cavitation — folded into your daily plan.",
    span: "",
  },
  {
    icon: Cookie,
    title: "Cravings & Hormonal Hunger",
    blurb:
      "Smart food swaps and hormone-supportive guidance for sugar, acne, bloating and emotional eating.",
    span: "",
  },
  {
    icon: BookOpen,
    title: "Community & Education",
    blurb:
      "Community cookbook, upvoted recipes, expert hormone guides and actionable wellness checklists.",
    span: "md:col-span-2",
  },
  {
    icon: LayoutDashboard,
    title: "Daily Wellness Dashboard",
    blurb:
      "Goals, habits, symptom insights, hormone-aware guidance — beautifully in one place.",
    span: "",
  },
  {
    icon: Brain,
    title: "Smart AI Insights",
    blurb:
      "“Your protein is low for recovery.” “Energy drops in luteal.” Patterns, surfaced for you.",
    span: "",
  },
  {
    icon: UserCog,
    title: "Deeply Personalised",
    blurb:
      "Body, fitness, diet, cycle, symptoms, lifestyle — every recommendation is yours.",
    span: "md:col-span-2",
  },
];

export const FAQS = [
  {
    q: "When does Feminine Ways launch?",
    a: "We're launching August 1, 2026. Anyone on the waitlist gets first access and the founding rate — $13/month for life, or just $10/month if billed annually upfront.",
  },
  {
    q: "How does the founding rate work?",
    a: "Join the waitlist before launch and your subscription is permanently priced at $13/month — or $10/month if you pay annually upfront ($120 once a year) — instead of the regular $25/month. As long as you stay subscribed, your rate never increases.",
  },
  {
    q: "Is this only for women on a cycle?",
    a: "No. Feminine Ways supports women across every life stage — from regular cycles to perimenopause, postpartum and beyond. The AI adapts to your body, not a textbook.",
  },
  {
    q: "Does the AI replace my doctor or dietitian?",
    a: "Feminine Ways is a wellness companion, not medical care. It augments your awareness with science-backed insights. Always consult a qualified provider for medical concerns.",
  },
  {
    q: "Can I cancel anytime?",
    a: "Yes. No contracts, no hidden fees. Cancel from the app in two taps.",
  },
  {
    q: "Will my data be private?",
    a: "Your data is yours. We never sell personal data, and your cycle and symptom information is encrypted end-to-end.",
  },
];
